"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactBox = exports.AboutBox = exports.FolderWrapper = exports.FolderBox = exports.FolderDropdownBox = exports.MoodieBox = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _StyledLayout = require("../../../StyledLayout");

var MoodieBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__MoodieBox",
  componentId: "sc-1e3i2s2-0"
})(["background:", ";"], function (props) {
  return props.theme.portfolioBackground1;
});
exports.MoodieBox = MoodieBox;
var FolderDropdownBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__FolderDropdownBox",
  componentId: "sc-1e3i2s2-1"
})(["box-sizing:border-box;padding:0 ", ";"], function (props) {
  return "".concat(props.padding, "px");
});
exports.FolderDropdownBox = FolderDropdownBox;
var FolderBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__FolderBox",
  componentId: "sc-1e3i2s2-2"
})(["width:100%;p{&:hover{color:", ";font-weight:bold;}}"], function (props) {
  return props.theme[props.colour];
});
exports.FolderBox = FolderBox;

var FolderWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Elements__FolderWrapper",
  componentId: "sc-1e3i2s2-3"
})(["position:relative;margin-bottom:32px;background:", ";.popover-wrapper{left:", ";}svg{path{fill:", "}}", ""], function (props) {
  return props.theme.portfolioBackground1;
}, function (props) {
  return "".concat(props.padding, "px");
}, function (props) {
  return props.theme[props.fontColor];
}, function (props) {
  var _props$theme, _props$theme2;

  return "\n    @media only screen and (max-width: ".concat(props === null || props === void 0 ? void 0 : props.theme.responsivePortfolioDesktop, "px) and (min-width: ").concat(props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.responsiveMedium, "px) {\n      width: ").concat(props === null || props === void 0 ? void 0 : props.width, "px;\n      margin: 0 auto;\n      margin-bottom: ").concat(props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.spacingLg, ";\n      #portfolio-moodie-popover > div:first-of-type {\n        padding: 0;\n        }\n    }\n  ");
});

exports.FolderWrapper = FolderWrapper;
var AboutBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__AboutBox",
  componentId: "sc-1e3i2s2-4"
})(["box-sizing:border-box;"]);
exports.AboutBox = AboutBox;
var ContactBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__ContactBox",
  componentId: "sc-1e3i2s2-5"
})(["box-sizing:border-box;padding:96px 0;"]);
exports.ContactBox = ContactBox;